import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/90 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-end h-20">
        {/* Book Now */}
        <a
          href="tel:0435075589"
          className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#FF8C42] text-white font-black text-sm px-6 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-fill" />
          BOOK NOW
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
